import axios from 'axios';
import * as URLS from '@/config/urls';

const url = 'https://junkit.vonigo.com/api/v1/data/'

const urlApi = 'https://junkit.vonigo.com/api/v1/'

export const getFranchiseByZip = function(data:any) {

		return new Promise<any>((resolve, reject) => {
			const queryUrl = `${urlApi}${URLS.FRANCHISE}`;

			const requestData = {
				securityToken: data.securityToken,
				method: '3',
				zipCode: data.zip,
			};
			axios
				.get(`${queryUrl}`, {
					params: requestData
				})
				.then(res => {
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	}


